import type { ButtonHTMLAttributes } from 'react'
import { Download, Eye, Pencil, Trash2, type LucideIcon } from 'lucide-react'

export type TableActionButtonAction = 'view' | 'edit' | 'delete' | 'download'

export interface TableActionButtonProps extends Omit<ButtonHTMLAttributes<HTMLButtonElement>, 'aria-label' | 'children'> {
  action: TableActionButtonAction
  ariaLabel: string
}

const actionIcons: Record<TableActionButtonAction, LucideIcon> = {
  view: Eye,
  edit: Pencil,
  delete: Trash2,
  download: Download,
}

const actionColors: Record<TableActionButtonAction, string> = {
  view: 'text-[#2563eb] hover:bg-[#eff6ff] focus:ring-[#2563eb]/20',
  edit: 'text-[#2563eb] hover:bg-[#eff6ff] focus:ring-[#2563eb]/20',
  download: 'text-[#2563eb] hover:bg-[#eff6ff] focus:ring-[#2563eb]/20',
  delete: 'text-[#e90a0a] hover:bg-[#fff1f1] focus:ring-[#e90a0a]/20',
}

export function TableActionButton({
  action,
  ariaLabel,
  className = '',
  type = 'button',
  disabled,
  ...props
}: TableActionButtonProps) {
  const Icon = actionIcons[action]

  return (
    <button
      type={type}
      aria-label={ariaLabel}
      disabled={disabled}
      className={`inline-flex h-8 w-8 items-center justify-center rounded-[6px] bg-transparent transition focus:outline-none focus:ring-2 disabled:cursor-not-allowed disabled:opacity-40 disabled:hover:bg-transparent ${actionColors[action]} ${className}`}
      {...props}
    >
      <Icon className="h-5 w-5" strokeWidth={2} aria-hidden="true" />
    </button>
  )
}
